import { useEffect, useRef } from "react";
import { AppointmentService } from "../services/AppointmentService";
import { ONLINE_PAYMENT_POLL_INTERVAL_MS, ONLINE_PAYMENT_POLL_TIMEOUT_MS, } from "../store/slices/paymentSlice";
export function useOnlinePaymentPolling({ status, sessionRef, popup, onFinish, pollIntervalMs = ONLINE_PAYMENT_POLL_INTERVAL_MS, pollTimeoutMs = ONLINE_PAYMENT_POLL_TIMEOUT_MS, postCloseGraceMs = 10000, }) {
    const onFinishRef = useRef(onFinish);
    onFinishRef.current = onFinish;
    useEffect(() => {
        if (status !== "awaiting" || !sessionRef)
            return;
        let cancelled = false;
        let inFlight = false;
        let popupClosedAt = null;
        const startedAt = Date.now();
        const poll = async () => {
            if (cancelled || inFlight)
                return;
            inFlight = true;
            try {
                const res = await AppointmentService.confirmOnlinePayment({
                    sessionRef,
                });
                if (cancelled)
                    return;
                if (res.status === "SUCCESS") {
                    onFinishRef.current({ status: "success" });
                    return;
                }
                if (res.status === "FAILED") {
                    onFinishRef.current({
                        status: "failed",
                        message: res.message,
                        reason: res.reason,
                    });
                    return;
                }
            }
            catch {
            }
            finally {
                inFlight = false;
            }
        };
        void poll();
        const intervalId = setInterval(() => {
            if (cancelled)
                return;
            const now = Date.now();
            const elapsed = now - startedAt;
            if (elapsed >= pollTimeoutMs) {
                cancelled = true;
                clearInterval(intervalId);
                onFinishRef.current({ status: "timeout" });
                return;
            }
            if (popup && popup.closed) {
                if (popupClosedAt === null) {
                    popupClosedAt = now;
                }
                else if (now - popupClosedAt >= postCloseGraceMs) {
                    cancelled = true;
                    clearInterval(intervalId);
                    onFinishRef.current({ status: "cancelled" });
                    return;
                }
            }
            void poll();
        }, pollIntervalMs);
        return () => {
            cancelled = true;
            clearInterval(intervalId);
        };
    }, [status, sessionRef, popup, pollIntervalMs, pollTimeoutMs, postCloseGraceMs]);
}
